export class Mortgages {
  constructor(balance, rate, payment, title) {
    this.estimatedBalance = balance;
    this.estimatedInterestRate = rate;
    this.estimatedPayment = payment;
    this.mortgageTitle = title;
  }
}
